import actions from './actions';

const { GROUP_LISTING_BEGIN, GROUP_LISTING_SUCCESS, GROUP_LISTING_ERR, PREVIEW_LISTING_BEGIN, PREVIEW_LISTING_SUCCESS, PREVIEW_LISTING_ERR, UPDATE_LISTING_BEGIN, UPDATE_LISTING_SUCCESS, UPDATE_LISTING_ERR } = actions;

const initState = {
  list: null,
  loading: false,
  error: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const BulkEditListingReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GROUP_LISTING_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GROUP_LISTING_SUCCESS:
      return {
        ...state,
        list: data,
        loading: false,
      };
    case GROUP_LISTING_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case PREVIEW_LISTING_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case PREVIEW_LISTING_SUCCESS:
      return {
        ...state,
        list: data,
        loading: false,
      };
    case PREVIEW_LISTING_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_LISTING_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_LISTING_SUCCESS:
      return {
        ...state,
        list: data,
        loading: false,
      };
    case UPDATE_LISTING_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default BulkEditListingReducer;
